import { atom, selector } from "recoil";
import { executeLinksAPI } from "../utils/LinksAPI";

//customer設定情報
export const customerConfigState = atom({
  key: 'customerConfigState',
  default: selector({
    key: 'customerConfigStateSelector',
    get: () => {
      // console.log("customerConfigState get");
      const config = {
        method: 'get',
      };
      return executeLinksAPI('fosterlinks/customer_config', config)
        .then(data => {
          return data;
        }).catch((error) => {
          console.error('customer_config get failed.');
          throw error;
        });
    }
  })
});
